import AgentList from './components/AgentList';
import ClassroomList from './components/ClassroomList';
import CoursesList from './components/CoursesList';
import ProfessorInfo from './components/ProfessorInfo';
import { EditButton } from '@refinedev/antd';
import { Flex, Form, Tabs, Tag } from 'antd';
import { IProfessor } from 'interfaces/professor';
import { PageHeader } from 'components/professor_area/PageHeader';
import { ShowLayout } from 'components/layout/layout/ShowLayout';
import { TeamOutlined } from '@ant-design/icons';
import { useCan, useShow } from '@refinedev/core';

export const ProfessorShow = () => {
  const canListClassroomProfessors = useCan({
    resource: 'classroom_professors',
    action: 'list'
  });
  const canListProfessorCourses = useCan({
    resource: 'professor_courses',
    action: 'list'
  });
  const canListAgents = useCan({ resource: 'agents', action: 'list' });

  const { queryResult } = useShow<IProfessor>();

  return (
    <ShowLayout title="Visualizar professor" isLoading={queryResult.isLoading}>
      <PageHeader
        title={queryResult?.data?.data?.name}
        icon={TeamOutlined}
        meta={
          <Flex>
            <Tag>{queryResult?.data?.data?.email}</Tag>
          </Flex>
        }
        actions={
          <EditButton
            id={queryResult?.data?.data?.id}
            type="primary"
            accessControl={{ hideIfUnauthorized: true }}
          ></EditButton>
        }
      />

      {!queryResult.isLoading && (
        <Tabs defaultActiveKey="info" className="custom-tabs">
          <Tabs.TabPane tab="Informações Gerais" key="info">
            <Form initialValues={queryResult?.data?.data} layout="vertical">
              <ProfessorInfo
                professorData={queryResult?.data?.data}
                type="show"
              />
            </Form>
          </Tabs.TabPane>
          {canListClassroomProfessors.data?.can && (
            <Tabs.TabPane tab="Responsável por turmas" key="classrooms">
              <ClassroomList />
            </Tabs.TabPane>
          )}
          {canListProfessorCourses.data?.can && (
            <Tabs.TabPane tab="Coordenação de Cursos" key="coordenation">
              <CoursesList />
            </Tabs.TabPane>
          )}
          {canListAgents.data?.can && (
            <Tabs.TabPane tab="Usuário" key="agent">
              <AgentList professorData={queryResult?.data?.data} type="show" />
            </Tabs.TabPane>
          )}
        </Tabs>
      )}
    </ShowLayout>
  );
};
